import { render, staticRenderFns } from "./AlertCircle.vue?vue&type=template&id=3d4fdabd"
import script from "./AlertCircle.vue?vue&type=script&lang=js"
export * from "./AlertCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports